<template>
  <div class="wait-workorder-bd tb">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item v-if="funcView.wait_assign_work_order_assign">
          <el-button
            type="primary"
            :disabled="!selectedRow.workOrderId"
            @click="editEvent"
          >{{funcView.wait_assign_work_order_assign}}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            @visible-change="saveTableColumn"
          >
            <el-button
              class="table-set"
              icon="icon icon-tableset"
            ></el-button>
            <el-dropdown-menu
              slot="dropdown"
              class="custom-dropdown"
            >
              <el-dropdown-item>
                <el-checkbox
                  v-model="isAllColumn"
                  @change="setAllColumn"
                >{{i18n.com_sel_all}}</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item
                v-for="(item, i) in tableColumn"
                :key="i"
              >
                <el-checkbox
                  v-model="item.selected"
                  @change="formatTable"
                >{{item.columnName}}</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item
          style="float: right; "
          v-if="funcView.wait_assign_work_order_export"
        >
          <el-button
            class="table-set"
            style="vertical-align: top;"
            @click="exportTable"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <el-input
            :placeholder="i18n.placeholder_order_code_body_num"
            v-model="formSearch.search"
            clearable
            @keyup.enter.native="getTableList('init')"
            style="width: 280px;"
          >
            <template slot="append">
              <div @click="getTableList('init')">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-select
            clearable
            v-model="formSearch.projectId"
            :placeholder="i18n.placeholder_select_project_name"
            style="vertical-align: top;"
          >
            <el-option
              v-for="(item, i) in projectList"
              :key="i"
              :label="item.locationName"
              :value="item.projectId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="table-bd"
      v-if="funcView.wait_assign_work_order_list"
    >
      <el-table
        ref="tb1"
        v-loading="isLoading"
        :size="allTableSize"
        :data="tableList"
        height="100%"
        @sort-change="sortChange"
        @filter-change="filterChange"
        highlight-current-row
        @current-change="onCurrentRow"
      >
        <!-- 配置列 -->
        <template v-for="(item, index) in tableColumn">
          <el-table-column
            v-if="item.selected && item.columnCode !== 'workOrderCode'"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom': null"
            :fixed="item.isLock ? 'right' : null"
            :column-key="item.columnCode"
            :filter-multiple="true"
            :filters="item.filters"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            v-if="item.selected && item.columnCode  === 'workOrderCode'"
            :key="index"
            :index="index"
            :prop="item.columnCode"
            :label="item.columnName"
            :width="item.width"
            :formatter="item.isFormat ? formatColumn : null"
            :sortable="item.isSort ? 'custom': null"
            :fixed="item.isLock ? 'right' : null"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
              >{{scope.row.workOrderCode}}</el-button>
            </template>
          </el-table-column>
        </template>
        <!-- 占位列 -->
        <el-table-column v-if="!tableColumn.length"></el-table-column>
      </el-table>
    </div>
    <div
      class="table-page"
      v-if="funcView.wait_assign_work_order_list"
    >
      <el-pagination
        border
        v-if="totalRows"
        @size-change="getTableList"
        @current-change="getTableList"
        :current-page.sync="formSearch.pageNum"
        :page-size.sync="formSearch.pageSize"
        :page-sizes="pageSizeList"
        layout="sizes, prev, pager, next, slot, jumper"
        :total="totalRows"
      ></el-pagination>
    </div>
    <aftersale-area-dialog
      v-if="dialogVisible"
      :data="dialogData"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getTableList('init')"
    ></aftersale-area-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import aftersaleAreaDialog from '../paramSet/children/aftersale_person_dialog.vue';

export default {
  name: 'wait_workorder',
  components: { aftersaleAreaDialog },
  data() {
    return {
      tableCode: 'waitworkorder',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        projectId: '',
        pageSize: 50,
        pageNum: 1
      },
      selectedRow: {},
      projectList: [],
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogData: {}
    };
  },
  mounted: function () {
    this.getFuncView();
    this.getTableList();
    this.getTableColumn();
    this.getProjectList();
  },
  methods: {
    onCurrentRow: function (row) {
      this.selectedRow = row || {};
    },
    // 项目下拉
    getProjectList: function () {
      this.$getJSON(apis.projectList).then((res) => {
        this.projectList = res.data;
      });
    },
    // 数据导出
    exportTable: function () {
      this.$exportFlie(apis.WorkOrderWaitExport, {}).then(() => { });
    },
    // 获取表格数据列表
    getTableList: function (data) {
      if (data === 'init') {
        this.formSearch.pageNum = 1;
      }
      this.$getJSON(apis.WorkOrderWaitPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 切换页
    onCurrentPage: function (page) {
      this.formSearch.pageNum = page;
      this.getTableList();
    },
    // 设置售后负责人
    editEvent: function () {
      this.dialogModel.type = 'wait_workorder';
      this.dialogModel.title = this.i18n.dialog_title_set_after_sales;
      this.dialogData.item = this.selectedRow;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang='scss'>
@import '@/style/colors.scss';

.wait-workorder-bd {
}
</style>
